export default "__VITE_ASSET__Bt71xRCI__"